import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-50">
      <div className="w-full max-w-site mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                黑料社区
              </span>
            </div>
            <p className="mt-4 text-xs md:text-sm text-background-50/70 leading-relaxed max-w-xs">
              评论、关注、私信，一个账号就能完成的社区互动。所有内容仅代表发布者个人观点，社区不参与事实判断。
            </p>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">
                <a href="#top" className="hover:text-accent-300 transition-colors">
                  {column.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-xs md:text-sm text-background-50/70 hover:text-accent-300 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-50/60">
            © 2026 黑料社区 · 用户评论互动 关注粉丝私信交流
          </p>
          <p className="text-xs text-background-50/60">
            本站为功能演示页面，所有内容与数据均为示意，不代表真实人物或事件。
          </p>
        </div>
      </div>
    </footer>
  );
}